import { PageContentHelp, Alert } from '@restaurant/core'
import { useWebHelpPageViewModel } from '../viewmodels/pages/WebHelpPageViewModel'
import { useContactRestaurantAlert } from '../hooks/useContactRestaurantAlert'

export default function HelpPage() {
  const viewModel = useWebHelpPageViewModel()
  const contactAlert = useContactRestaurantAlert()

  const helpProps = viewModel.getPageContentHelpProps()

  // Override "Call Restaurant" tile to show Alert instead of firing tel: directly
  const tiles = helpProps.tiles?.map((tile) =>
    tile.id === 'call-restaurant'
      ? { ...tile, onClick: contactAlert.showForCurrentLocation }
      : tile
  )

  return (
    <>
      <PageContentHelp
        {...helpProps}
        tiles={tiles}
        testID="help-page"
        accessibilityLabel="Help and support options"
      />
      {/* Required-prop fallbacks: alertProps is Partial<AlertProps>; when the
          hook is inactive it returns { visible: false } and Alert renders null,
          so these placeholders are never displayed. Spread wins when active. */}
      <Alert
        title=""
        description=""
        primaryAction={{ text: '', onPress: () => {} }}
        {...contactAlert.alertProps}
      />
    </>
  )
}
